import { REQUEST_STATUS } from '@/constants/request-status'
import { ReviewCard } from '../review-card'

interface ViewStudentObservationProps {
  observation?: string
  requestStatusId?: string
  withLabel?: boolean
}

export const ViewStudentObservation = ({
  observation,
  requestStatusId,
  withLabel = true
}: ViewStudentObservationProps) => {
  const defaultObservationTitle: Record<string, string> = {
    [REQUEST_STATUS.GRANT.id]: 'Observação para o aluno',
    [REQUEST_STATUS.DENY.id]: 'Justificativa para o aluno'
  }

  const defaultDescription: Record<string, string> = {
    [REQUEST_STATUS.GRANT.id]:
      'Escreva para o aluno uma Observação para o deferimento',
    [REQUEST_STATUS.DENY.id]:
      'Escreva para o aluno uma justificativa para o indeferimento'
  }

  const currentObservationTitle =
    defaultObservationTitle[requestStatusId ?? ''] ?? 'Observação para o aluno'

  const currentDescription =
    defaultDescription[requestStatusId ?? '']
    ?? 'Escreva para o aluno uma observação sobre o deferimento'

  return (
    <ReviewCard
      title={currentObservationTitle}
      titleClassName="text-[var(--brand-blue-4)]"
    >
      <div className="p-6">
        {withLabel && (
          <p className="text-foreground/80 mb-4">{currentDescription}</p>
        )}
        <div className="min-h-30 border border-ring/50 rounded-lg flex">
          <textarea
            disabled={true}
            className="w-full border-none flex-grow p-4 resize-none outline-none"
          >
            {observation}
          </textarea>
        </div>
      </div>
    </ReviewCard>
  )
}
